import React, { useState } from 'react';
import { Stack, Typography, TextField, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLocalization } from 'src/context/LocalizationContext';
import SvgColor from 'src/components/svg-color';


export default function CargoMessageForm() {
    const { partner } = useParams();
    const { language } = useLocalization();

    const [contactForm, setContactForm] = useState({});    

    let partnerName = '';
    if (partner === 'aras-kargo') {
        partnerName = 'Aras Kargo';
    } else if (partner === 'dhl') {
        partnerName = 'DHL Kargo';
    }

    const handleSubmit = () => {
        // gönderme işlemi buraya
        console.log({ contactForm });
    };

    return (
        <>

            <Stack spacing={2} px={12}>
                <Stack spacing={3}  maxWidth={680} width={'100%'}>
                    <Stack spacing={3}>
                       
                        <Stack direction="row" alignItems="center" justifyContent='space-between' spacing={2}>
                            <Typography sx={{ color: '#D1D1D1', fontSize: '16px', fontWeight: 400 }}>
                                {partnerName === 'DHL Kargo'
                                    ? partnerName
                                    : `${partnerName} - ${language.commons.labels.embezzle}`}
                            </Typography>
                            <Stack onClick={() => window.history.back()} padding={2} sx={{ boxShadow: 1, borderRadius: '6px', cursor: 'pointer' }}>
                                <SvgColor                                    
                                    src="/assets/icons/left-arrow.svg"
                                    sx={{
                                    width: 15,
                                    height: 15
                                    }}
                                />
                            </Stack>
                        </Stack>

                        <Typography
                            sx={{
                                my: 9,
                                pb: 1,
                                borderBottom: 1,
                                borderColor: '#ECE8E8',
                                fontWeight: 'bold',
                            }}
                            >
                            {language.commons.request.request_summary}
                        </Typography>
                    </Stack>

                    <TextField
                        label="Başlık"
                        placeholder="Mesajınızın Başlığı"
                        fullWidth
                        value={contactForm.title || ''}
                        onChange={(e) => setContactForm({ ...contactForm, title: e.target.value })}
                    />

                    <TextField
                        label="İçerik"
                        placeholder="Mesajınızın İçeriği"
                        fullWidth
                        multiline
                        minRows={6}
                        value={contactForm.content || ''}
                        onChange={(e) => setContactForm({ ...contactForm, content: e.target.value })}
                    />

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#D93025',
                            width: '100%',
                            maxWidth: 235,
                            color: '#fff',
                            alignSelf: 'flex-start',
                            marginLeft: 'auto !important',
                            px: 5,
                            py: 1.5,
                            '&:hover': {
                                backgroundColor: '#b0241d'
                            }
                        }}
                        onClick={handleSubmit}
                    >
                        Gönder
                    </Button>
                </Stack>
            </Stack>
        </>
    );
}
